module.exports = __webpack_public_path__ + "static/media/lupa.6685adba.png";